import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DateTime, Duration } from 'luxon';

const STORAGE_KEY = 'cashVoucherPopup_lastShown';
const SHOW_INTERVAL = Duration.fromObject({ minutes: 30 });

@Injectable({
  providedIn: 'root',
})
export class CashVoucherPopupService {
  visible$ = new BehaviorSubject<boolean>(false);

  shouldShow(): boolean {
    const lastShown = localStorage.getItem(STORAGE_KEY);
    if (!lastShown) {
      return true;
    }
    const elapsed = DateTime.now().diff(DateTime.fromISO(lastShown));
    return elapsed >= SHOW_INTERVAL;
  }

  open(): void {
    this.markAsShown();
    this.visible$.next(true);
  }

  close(): void {
    this.visible$.next(false);
  }

  private markAsShown(): void {
    localStorage.setItem(STORAGE_KEY, <string>DateTime.now().toISO());
  }
}
